
import { defineComponent, ref } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import store from "../store";
import Skeleton from "primevue/skeleton";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "UserOffers",
  components: {
    Skeleton,
  },
  props: [],
  setup(props) {
    const isLoadingOffers = ref(false);
    const error = ref(null);
    const offers = ref(null);
    const router = useRouter();
    const route = useRoute();
    const getUserOffers = async () => {
      isLoadingOffers.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserOffers`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          offers.value = fetchedOrders.offersList;
          isLoadingOffers.value = false;
        } else {
          console.log("error!");
          isLoadingOffers.value = false;
        }

        isLoadingOffers.value = false;
        console.log(offers.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      offers,
      getUserOffers,
      isLoadingOffers,
      error,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getCreatedDate(date: any) {
      function pad(n: any) {
        return n < 10 ? "0" + n : n;
      }
      const now = new Date(date);
      const tz = now.getTimezoneOffset();
      const sign = tz > 0 ? "-" : "+";
      const hours = pad(Math.floor(Math.abs(tz) / 60));
      const minutes = pad(Math.abs(tz) % 60);
      const tzOffset = sign + hours + ":" + minutes;
      const localDateTime =
        now.getFullYear() +
        "-" +
        pad(now.getMonth() + 1) +
        "-" +
        pad(now.getDate()) +
        "T" +
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds());
      const eventDate = {
        utc: now.toISOString(),
        local: localDateTime,
        tzOffset: tzOffset,
      };

      const localDateString = eventDate.local;
      const localDate = new Date(localDateString);

      let created: any = new Date(localDate);
      if (tz < 0) {
        created.setHours(
          created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
      } else if (tz > 0) {
        created.setHours(
          created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
      }

      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };

      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes() +
        " (UTC " +
        tzOffset +
        ")"
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
    getTicketStatus(num: number) {
      if (num == 1) {
        return "Заявка создана";
      } else if (num == 2) {
        return "Заявка в работе";
      } else if (num == 3) {
        return "Заявка успешно решена";
      } else if (num == 4) {
        return "Требуется обратная связь";
      } else if (num == 5) {
        return "Заявка закрыта";
      } else if (num == 6) {
        return "Отказ по заявке";
      }
    },
  },
  created() {
    this.getUserOffers();
  },
});
